import { ChangeEvent } from 'react';
import { TextField } from '@mui/material';
import { OtpStrategy } from 'hooks/useAuthForm';
import { formatPhoneNumber } from 'utils/phone';

type Props = {
  otpStrategy: OtpStrategy;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  error?: string | null;
  placeholder?: string;
  autoComplete?: string;
  label?: string;
  autoFocus?: boolean;
  disabled?: boolean;
};

export default function IdentifierField({
  otpStrategy,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  autoComplete,
  label,
  autoFocus,
  disabled
}: Props) {
  if (otpStrategy === 'email') {
    return (
      <TextField
        fullWidth
        type="email"
        label={label}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={!!error}
        helperText={error ?? undefined}
        placeholder={placeholder}
        autoComplete={autoComplete}
        inputProps={{ 'aria-label': 'Email' }}
        autoFocus={autoFocus}
        disabled={disabled}
      />
    );
  }

  // Нормализуем номер прямо при вводе: подставляем +7, превращаем 8 → 7,
  // форматируем как «+7 (XXX) XXX-XX-XX». Это избавляет от ситуаций вроде
  // «+ (903) 444 44 44», когда пользователь забыл ввести семёрку.
  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.target.value = formatPhoneNumber(e.target.value);
    onChange(e);
  };

  return (
    <TextField
      size="medium"
      type="tel"
      error={!!error}
      helperText={error ?? undefined}
      placeholder={placeholder ?? '+7 (900) 000-00-00'}
      autoComplete={autoComplete ?? 'tel'}
      inputProps={{ 'aria-label': 'Телефон', inputMode: 'tel', maxLength: 18 }}
      fullWidth
      label={label ?? 'Телефон'}
      autoFocus={autoFocus}
      value={value}
      onChange={handlePhoneChange}
      onBlur={onBlur}
      disabled={disabled}
    />
  );
}
